import React, { useState, useEffect } from "react";
import { Table, Modal, Button } from "react-bootstrap";
import IconButton from "@mui/material/IconButton";
import Swal from "sweetalert2";
import Hexapi from "../usefulcomps/HexAPI/Hexapi";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Tooltip from "@mui/material/Tooltip";
import QuotationForm from "./QuotationForm";
import axios from "axios";

function QuotationLog(props) {
  const [modalLoading, setModalLoading] = useState(true);
  const [QuotationRowdata, SetQuotationRowdata] = useState([]);
  const [QuotationHeaders, setQuotationHeaders] = useState([]);
  const [AddQuotationDisable, setAddQuotationDisable] = useState(false);
  const [loadingPIIds, setLoadingPIIds] = useState(new Set()); // ✅ per-row loading

  const fetchRowDetails = async () => {
    setModalLoading(true);
    let obj = {
      query: `[dbo].[CRM_Proc_QuotationLog_GetList] @agentID='{0}', @EnquiryID='{1}'`,
      queryArr: [`${props.AgentID}`, `${props.enquiryID}`],
    };
    try {
      const resp = await Hexapi(obj);
      console.log("Row details:", resp);

      // ✅ Always set disable flag regardless of row count
      setAddQuotationDisable(Number(resp["config"]?.[0]?.["adddisable"]) === 1);

      if (resp[""].length > 0) {
        SetQuotationRowdata(resp[""]);
        setQuotationHeaders(Object.keys(resp[""][0]));
      } else {
        SetQuotationRowdata([]);
        setQuotationHeaders([]);
      }
    } catch (err) {
      console.error("Error fetching row details:", err);
    } finally {
      setModalLoading(false);
    }
  };

  // Check if MarkedAsPI column exists
  const hasMarkedAsPI = QuotationHeaders.includes("markedaspi");

  // Check if ALL values in MarkedAsPI are 0
  const allMarkedAsPIZero =
    hasMarkedAsPI &&
    QuotationRowdata.every((row) => Number(row["markedaspi"]) === 0);

  // Check if ANY value in MarkedAsPI is 1
  const anyMarkedAsPIOne =
    hasMarkedAsPI &&
    QuotationRowdata.some((row) => Number(row["markedaspi"]) === 1);

  // Reorder headers: put MarkedAsPI first if it exists
  const orderedHeaders = hasMarkedAsPI
    ? ["markedaspi", ...QuotationHeaders.filter((h) => h !== "markedaspi")]
    : QuotationHeaders;

  useEffect(() => {
    console.log(props.isOpen);
    if (props.isOpen) {
      fetchRowDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isOpen]);

  const handleMarkAsPI = (row, rowIndex) => {
    console.log(row);
    Swal.fire({
      title: "Send PI?",
      text: "Are you sure you want to Send PI?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Mark it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await markAsPIHandler(row["quotation id"]);
      }
    });
  };

  const formatDate = (dateInput) => {
    if (!dateInput) return "";

    // Handle SQL date wrapper objects like { date: '2026-06-08 00:00:00.000' }
    if (typeof dateInput === "object" && dateInput !== null && dateInput.date) {
      dateInput = dateInput.date;
    }

    let d = null;

    if (dateInput instanceof Date) {
      d = dateInput;
    } else {
      let s = String(dateInput).trim();

      if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}/.test(s)) {
        s = s.replace(" ", "T");
      }

      d = new Date(s);

      if (isNaN(d.getTime())) {
        const datePart = s.split("T")[0].split(" ")[0];
        const parts = datePart.split("-");
        if (parts.length === 3) {
          const y = Number(parts[0]);
          const m = Number(parts[1]);
          const day = Number(parts[2]);
          if (!Number.isNaN(y) && !Number.isNaN(m) && !Number.isNaN(day)) {
            d = new Date(y, m - 1, day);
          }
        }
      }

      if (!d || isNaN(d.getTime())) return "";
    }

    return (
      String(d.getDate()).padStart(2, "0") +
      "/" +
      String(d.getMonth() + 1).padStart(2, "0") +
      "/" +
      d.getFullYear()
    );
  };

  const markAsPIHandler = async (quotationid) => {
    // ✅ Set this quotation ID as loading
    setLoadingPIIds((prev) => new Set(prev).add(quotationid));
    try {
      const obj = {
        query: `[dbo].[CRM_Proc_QuotationLog_MarkAsPI] @QuotationID='{0}', @AgentID='{1}',@EnquiryID='{2}'`,
        queryArr: [`${quotationid}`, `${props.AgentID}`, `${props.enquiryID}`],
      };
      const resp = await Hexapi(obj);
      console.log(resp);
      if (resp?.[""]?.[0]?.command === 1) {
        const postData = {
          ServiceCharge: resp[""][0]["servicecharge"],
          TransportationCost: resp[""][0]["transportationcost"],
          Discount: resp[""][0]["discount"],
          EnquiryID: props.enquiryID,
          Today: new Date().toLocaleDateString("en-GB"),
          OpportunityReferenceNumber: resp[""][0]["opportunityreferencenumber"],
          Validity: formatDate(resp[""][0]["validity"]),
          CompanyName: resp[""][0]["companyname"],
          OfficeAddress: resp[""][0]["officeaddress"],
          SiteAddress: resp[""][0]["siteaddress"],
          City: resp[""][0]["city"],
          GstNumber: resp[""][0]["gstnumber"],
          EmailID: resp[""][0]["emailid"],
          CustomerName: resp[""][0]["customername"],
          Rating: resp[""][0]["rating"],
          OtherSpecifications: resp[""][0]["otherspecifications"],
          Pincode: resp[""][0]["pincode"],
          Panel: resp[""][0]["panel"],
          State: resp[""][0]["state"],
          Qty: resp[""][0]["qty"],
          EngineModel: resp[""][0]["enginemodel"],
          Quotation: resp[""][0]["quotation"],
          QuotationID: resp[""][0]["quotationid"],
          ContactNumber: resp[""][0]["contactnumber"],
          Revision: resp[""][0]["revisionno"],
        };

        const res = await fetch(`${process.env.PUBLIC_URL}/Apiinfo.json`);
        const data = await res.json();
        if (!data?.apipath) throw new Error("API Path missing");

        const url = `${data.apipath}SendPI.php`;

        const response = await axios.post(url, postData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        // ✅ SUCCESS SWAL
        await Swal.fire({
          icon: "success",
          title: "PI Sent",
          text: "PI email has been sent successfully.",
          confirmButtonText: "OK",
        });
        fetchRowDetails();
      }
    } catch (err) {
      console.error("Error marking as PI:", err);
      Swal.fire("Error", "Something went wrong.", "error");
    } finally {
      // ✅ Remove this quotation ID from loading set
      setLoadingPIIds((prev) => {
        const next = new Set(prev);
        next.delete(quotationid);
        return next;
      });
    }
  };

  const renderCell = (col, row, rowIndex) => {
    if (col === "markedaspi") {
      const val = Number(row["markedaspi"]);
      const quotationId = row["quotation id"];
      const isLoadingThis = loadingPIIds.has(quotationId); // ✅ check per-row

      if (allMarkedAsPIZero) {
        return (
          <td
            key={col}
            style={{ textAlign: "center", verticalAlign: "middle" }}
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleMarkAsPI(row, rowIndex);
              }}
              disabled={isLoadingThis} // ✅ disable only this row's button
              style={{
                padding: "2px 10px",
                fontSize: "14px",
                backgroundColor: isLoadingThis ? "#555" : "black",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: isLoadingThis ? "not-allowed" : "pointer",
                whiteSpace: "nowrap",
                minWidth: "80px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                opacity: isLoadingThis ? 0.75 : 1,
              }}
            >
              {isLoadingThis ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{
                      width: "12px",
                      height: "12px",
                      borderWidth: "2px",
                    }}
                  />
                  Sending...
                </>
              ) : (
                "Send PI"
              )}
            </button>
          </td>
        );
      }

      if (anyMarkedAsPIOne) {
        return (
          <td
            key={col}
            style={{ textAlign: "center", verticalAlign: "middle" }}
          >
            {val === 1 ? (
              <span
                style={{
                  color: "#16a34a",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
                title="Marked as PI"
              >
                ✓
              </span>
            ) : (
              ""
            )}
          </td>
        );
      }

      return (
        <td key={col} style={{ textAlign: "center" }}>
          {String(row[col] ?? "")}
        </td>
      );
    }

    const value = row[col];
    let displayValue = "";

    if (value && typeof value === "object" && value.date) {
      displayValue = new Date(value.date).toLocaleDateString("en-IN");
    } else if (value instanceof Date) {
      displayValue = value.toLocaleDateString("en-IN");
    } else {
      displayValue = String(value ?? "");
    }

    return (
      <td key={col} style={{ textAlign: "center" }}>
        {displayValue}
      </td>
    );
  };

  return (
    <>
      <Tooltip title="Quotation">
        <AssignmentIcon
          style={{ cursor: "pointer", fontSize: "25px" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            props.onOpen?.();
          }}
        />
      </Tooltip>

      <Modal
        show={props.isOpen}
        onHide={() => props.onClose?.()}
        dialogClassName="custom-modal"
        scrollable
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header style={{ backgroundColor: "#f5f9ff" }}>
          <div className="w-100">
            <div>
              <strong>Quotation Log</strong>
            </div>
            <div className="d-flex gap-4 mt-2">
              <span>
                <strong>EnquiryID:</strong> {props.enquiryID}
              </span>
              <span>
                <strong>CustomerName:</strong> {props.customerName}
              </span>
            </div>
          </div>
          <div className="d-flex align-items-center">
            {!modalLoading && (
              <div style={{ cursor: "pointer", marginRight: "10px" }}>
                <QuotationForm
                  AgentID={props.AgentID}
                  enquiryID={props.enquiryID}
                  customerName={props.customerName}
                  RefreshLogs={() => fetchRowDetails()}
                  disabled={AddQuotationDisable}
                />
              </div>
            )}
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => props.onClose?.()}
            />
          </div>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "85vh", overflowY: "auto" }}>
          {!modalLoading ? (
            QuotationRowdata.length > 0 ? (
              <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                <Table
                  striped
                  className="custom-table w-100"
                  size="sm"
                  style={{ borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr>
                      {orderedHeaders.map((s, index) => (
                        <th
                          key={index}
                          style={{
                            background: "#000",
                            color: "white",
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                            whiteSpace: "nowrap",
                            textAlign: "center",
                          }}
                        >
                          {s.toUpperCase()}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody style={{ whiteSpace: "nowrap", cursor: "pointer" }}>
                    {QuotationRowdata.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {orderedHeaders.map((col) =>
                          renderCell(col, row, rowIndex),
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "200px" }}
              >
                <span>No Records!</span>
              </div>
            )
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default QuotationLog;
